var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('router-link',{attrs:{"to":"/diagnosis_stock"}},[_c('div',{staticClass:"openDiagnosis"})]),_vm._v(" "),_c('router-link',{attrs:{"to":"/found_winners"}},[_c('div',{staticClass:"winners_diagnosis"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262cdd30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WinnersDiagnosis.vue
// module id = null
// module chunks = 